export default "__VITE_ASSET__3970aa57__"